<template>
    <div>
        <div v-if="isOnDatesTab" class="promotion-period">
            <div class="promotion-period__label">
                {{ toSentenceCase($t('planning.promotionsMaintenance.dates.period')) }}
            </div>
            <div class="promotion-period__start-end">
                {{ toSentenceCase($t('planning.promotionsMaintenance.dates.startEnd')) }}
            </div>
            <component
                v-bind="field"
                :is="getVuexComponent(field.type)"
                v-for="(field, index) in fields"
                v-show="!field.hidden"
                :key="'child' + index"
                :vuex-module="vuexModule"
                :namespace="computedNamespace"
                :context="context"
                :parsed-field="parseFieldDefinition(field)"
                :disabled="isDisabledField({ editable: resolveValue(field.editable) })"
                :edit-mode="editMode"
                @change="onDateChange"
            />
        </div>
    </div>
</template>

<script>
import vuexFormMixin from '@/js/mixins/vuex-form';
import UXEvents from '@enums/ux-events';
import { mapState, mapMutations } from 'vuex';
import promotionTabs from '@enums/promotion-tabs';

const { date } = promotionTabs;

export default {
    mixins: [vuexFormMixin],
    props: {
        cacheDom: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({}),
    computed: {
        ...mapState('promotions', ['changesetApplyInProgress', 'selectedPromotionMaintenanceTab']),
        isOnDatesTab() {
            return this.cacheDom || this.selectedPromotionMaintenanceTab === date;
        },
    },
    methods: {
        ...mapMutations('promotions', ['setUnsavedPromotion']),
        onDateChange() {
            this.$emit(UXEvents.updateSuppliersForPromotion, {
                namespace: this.computedNamespace,
            });
            this.setUnsavedPromotion({ namespace: this.namespace, tab: date, value: true });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.promotion-period {
    display: flex;
    align-items: center;
    margin-top: 2rem;
    padding: 1rem;
    background-color: $promo-grey-4;

    .promotion-period {
        &__label {
            margin-right: 3rem;
            font-weight: 600;
        }

        &__start-end {
            margin-right: 1rem;
        }

        &__calendar {
            width: 17rem;
        }

        &__submit-btn {
            margin-left: auto;
        }
    }
}
</style>

<style lang="scss">
.promotion-period {
    .vuex-form > * {
        margin: 0;
    }
}
</style>
